import UserService from "./UserService"

const parseJsonResponse = async (response) => {
    const contentType = response.headers.get('content-type') || '';
    if (!response.ok) {
        const requestId = response.headers.get('x-request-id');
        console.error(`[api] HTTP ${response.status} ${response.url}${requestId ? ` [x-request-id: ${requestId}]` : ''}`);
    }
    if (!contentType.includes('application/json')) {
        throw new Error(`API returned non-JSON response (${response.status}): ${contentType}`);
    }
    return response.json();
};

export const get = async (path) => {

    const additonalHeaders = await UserService.getUserHeader()

    const response = await fetch(`${process.env.REACT_APP_PUBLIC_API_URL}/${path}`, {
        method: 'GET',
        headers: {
            ...additonalHeaders
        },
    })
    return response
}

export const getJson = async (path) => {

    const additonalHeaders = await UserService.getUserHeader()

    const response = await fetch(`${process.env.REACT_APP_PUBLIC_API_URL}/${path}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...additonalHeaders
        },
    })
    return parseJsonResponse(response);
}

export const putJson = async (path, body, baseUrl = process.env.REACT_APP_PUBLIC_API_URL, additionalHeaders = {}) => {

    const additonalHeaders = await UserService.getUserHeader()

    const response = await fetch(`${baseUrl}/${path}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            ...additonalHeaders
        },
        body: JSON.stringify(body)
    })
    return parseJsonResponse(response);
}

export const postJson = async (path, body, baseUrl = process.env.REACT_APP_PUBLIC_API_URL, additionalHeaders = {}) => {

    const additonalHeaders = await UserService.getUserHeader()

    const response = await fetch(`${baseUrl}/${path}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...additonalHeaders
        },
        body: JSON.stringify(body)
    })
    return parseJsonResponse(response);
}

export const deleteJson = async (path, body, baseUrl = process.env.REACT_APP_PUBLIC_API_URL, additionalHeaders = {}) => {

    const additonalHeaders = await UserService.getUserHeader()

    const response = await fetch(`${baseUrl}/${path}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            ...additonalHeaders
        },
        body: body ? JSON.stringify(body) : undefined
    })
    return parseJsonResponse(response);
}

export const postRaw = async (path, body, baseUrl = process.env.REACT_APP_PUBLIC_API_URL, additionalHeaders = {}) => {

    const additonalHeaders = await UserService.getUserHeader()

    const response = await fetch(`${baseUrl}/${path}`, {
        method: 'POST',
        headers: {
            ...additonalHeaders
        },
        body: body
    })
    return parseJsonResponse(response);
}
